<template>
  <FilterButton
    :label="props.label"
    :value-representation="valueRepresentation"
    :allow-reset="modelValue.length > 0"
    @reset="emit('update:modelValue', [])">
    <div class="p-3">
      <v-select
        multiple
        :close-on-select="false"
        :modelValue="modelValue"
        @update:modelValue="emit('update:modelValue', $event)"
        :options="props.options"
        :reduce="(o: any) => o.value"
        :placeholder="props.hint || props.label"
        @click.stop />
    </div>
  </FilterButton>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FilterButton } from '@prospective/lithium';

interface Option {
  label: string;
  value?: any;
}

const props = withDefaults(
  defineProps<{
    label: string;
    modelValue: any[];
    options: Option[];
    hint?: string;
  }>(),
  {
    hint: '',
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: any[]): void;
  (e: 'reset'): void;
}>();

const valueRepresentation = computed(() => {
  if (props.modelValue.length === 0) return '';
  if (props.modelValue.length === 1) {
    const opt = props.options.find((o) => o.value === props.modelValue[0]);
    return opt?.label || String(props.modelValue[0]);
  }
  return `${props.modelValue.length} selected`;
});
</script>
